import { compose } from 'redux';
import { query } from './API';
import BrandDistribution from './BrandDistribution';
import withRequestTracker from '../../../../utils/composition/withRequestTracker';

const composedBrandDistribution = compose(withRequestTracker({ query }))(BrandDistribution);

export default composedBrandDistribution;
